import React from "react"
import SEO from "../components/seo"

const NotFoundPage = () => {
  
return (
  <div>
    <SEO title="404: Not found" />
    <h1>NO ENCONTRADO</h1>
    <p>Has llegado a una ruta que no existe... que tristeza.</p>
  </div>
  )
}

export default NotFoundPage
